import BlankBill from "../blankbill";
import { connect } from "react-redux";
import React, { Component } from "react";
import TableBill from "../../tableProvider/table-bill";
import { getBills, getTotalElements } from "../../../../Redux/reducer/bills";
import {
  clearBillsList,
  getBillsList,
} from "../../../../Redux/actions/billActions";

export class ApprovalsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      sizePerPage: this.props.pageSize,
      filters: [
        {
          property: "status",
          operator: "in",
          value: "PENDING,APPROVED_PARTIALLY,DELETE_PENDING",
        },
      ],
      componentReady: false,
    };
  }

  componentDidMount() {
    if(this.props.pageSize !== 10){
      this.props.handlePageSizeSelection(10);
      return;
    }

    this.props.handleBillSelection(this.props.defaultBillSelection);
    this.props.reset();
    return this.loadBills();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pageSize !== this.props.pageSize) {
      this.props.setModal(true)
      this.setState({ sizePerPage: this.props.pageSize, page: 0 }, () => {
        this.loadBills()
      });
    }
  
    const customFilters = this.getFilters();
    if (JSON.stringify(customFilters) !== JSON.stringify(this.state.filters)) {
      this.setState({ filters: customFilters });
      this.loadBills();
    }
  }

  componentWillUnmount() {
    this.props.handlePageSizeSelection(10);
    this.props.clearBillsList();
    this.props.setModal(true);
  }

  loadBills() {
    const customFilters = this.getFilters();
    return this.props
      .getBillsList(this.state.page, this.state.sizePerPage, customFilters)
      .then(() => {
        this.props.setModal(false);
        this.setState({ componentReady: true, filters: customFilters });
      });
  }

  getFilters() {
    const baseFilter = [
      {
        property: "status",
        operator: "in",
        value: "PENDING,APPROVED_PARTIALLY,DELETE_PENDING",
      },
    ];
    return [...this.props.filters, ...baseFilter];
  }

  getBillsHandler = (page, sizePerPage, paramfilters, sortFilter) => {
    this.props.setModal(true);
    return this.props
      .getBillsList(page, sizePerPage, paramfilters, sortFilter)
      .then(() => {
        this.setState({ page: page, sizePerPage: sizePerPage });
        this.props.setModal(false);
      });
  };

  render() {
    const { componentReady, page, sizePerPage, filters } = this.state;
    const { bills, totalElements, updateCreditLine, billSelection, handleBillSelection } = this.props;

    return componentReady ? (
      bills.length > 0 ? (
        <TableBill
          data={bills}
          page={page}
          getBillsList={this.getBillsHandler}
          totalSize={totalElements}
          sizePerPage={sizePerPage}
          filters={filters}
          updateCreditLine={updateCreditLine}
          approvedTo="APPROVED"
          rejectedTo="REJECTED"
          needToken={true}
          mode="approved"
          updateOnSubmit={true}
          defaultBillSelection={this.props.defaultBillSelection}
          billSelection={billSelection}
          handleBillSelection={handleBillSelection}
          excludedStatus={this.props.excludedStatus}
        />
      ) : (
        <BlankBill />
      )
    ) : null;
  }
}

export const mapStateToProps = (state) => {
  return {
    bills: getBills(state),
    totalElements: getTotalElements(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    getBillsList: (page, size, filters, sort) =>
      dispatch(getBillsList(page, size, filters, sort)),
    clearBillsList: (payload) => dispatch(clearBillsList(payload)),
  };
};

export default connect(mapStateToProps, mapDispatch)(ApprovalsList);
